module.exports = __webpack_public_path__ + "static/media/sell.262abceb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/event-toolbar/sell.svg
// module id = 774
// module chunks = 0